import React from 'react';

import { Alert } from '@mui/material';

export default function RoomTypesTab() {
  return <Alert severity="info">Coming soon.</Alert>;
}
